module.exports = __webpack_public_path__ + "img/logo_nos.2def771b.svg";